
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-21596d8a\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"includePaths\":[\"./src/styles\"],\"data\":\"@import \\\"./src/styles/common\\\";\",\"sourceMap\":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Products.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Products.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-21596d8a\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Products.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Products.vue
// module id = 1042
// module chunks = 1